function addBusinessDays(startDate, days) {
  const result = new Date(startDate);
  let count = 0;
  while (count < days) {
    result.setDate(result.getDate() + 1);
    if (result.getDay() !== 0 && result.getDay() !== 6) {
      count++;
    }
  }
  return result;
}

function formatDate(date) {
  const months = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ];
  return `${date.getDate()} ${months[date.getMonth()]}`;
}

document.addEventListener("DOMContentLoaded", function () {
  /* Product bundle */
  document
    .querySelectorAll(".product__bundle-product-select")
    ?.forEach((select) => {
      // We save the previous index
      const previousIndex = parseInt(select.selectedIndex);
      select.addEventListener(
        "change",
        function () {
          // We toggle the active class on the correct product bundle item
          select
            ?.closest(".product__bundle")
            ?.querySelectorAll(".product__bundle-item")
            ?.forEach((item, index) => {
              item.classList.toggle(
                "product__bundle-item--active",
                index === parseInt(select.selectedIndex)
              );
            });
          // We set the previous index back to the select
          select.selectedIndex = previousIndex;
        },
        {
          passive: true,
        }
      );
    });

  /* Product shipping estimate */
  document
    .querySelectorAll(".product__shipping-estimate")
    .forEach((shippingEstimate) => {
      if (shippingEstimate) {
        const numberOfDays =
          parseInt(shippingEstimate.dataset.number_of_days) || 0;
        const today = new Date();
        const deliveryDate = addBusinessDays(today, numberOfDays);
        const formattedDate = formatDate(deliveryDate);
        shippingEstimate.querySelector(
          ".product__shipping-estimate-date"
        ).textContent = formattedDate;
      }
    });

  /* Video slider */
  const videoSliderButtons = document.querySelectorAll(".video-slider__button");
  videoSliderButtons.forEach((button) => {
    button.addEventListener("click", () => {
      videoSliderButtons.forEach((_button) => {
        _button.classList.toggle(
          "video-slider__button--active",
          _button === button || (_button != button && button.disabled)
        );
      });
    });
  });

  let currentPlayingVideo = null;

  document
    .querySelectorAll(".video-slider__video")
    .forEach(function (videoContainer) {
      const preview = videoContainer.querySelector(
        ".video-slider__video-preview"
      );
      const video = videoContainer.querySelector("video");
      const playButton = videoContainer.querySelector(
        ".video-slider__play-button"
      );
      const playIcon = playButton.querySelector(".icon-play");
      const pauseIcon = playButton.querySelector(".icon-pause");

      video.muted = false;

      videoContainer.addEventListener("click", function () {
        if (video.classList.contains("video-slider__video--active")) {
          video.pause();
          video.currentTime = 0;
          video.classList.remove("video-slider__video--active");
          preview.classList.remove("video-slider__video-preview--hidden");
          playIcon.classList.remove("icon--hidden");
          pauseIcon.classList.add("icon--hidden");
          currentPlayingVideo = null;
        } else {
          if (currentPlayingVideo && currentPlayingVideo !== video) {
            const previousContainer = currentPlayingVideo.closest(
              ".video-slider__video"
            );
            const previousPreview = previousContainer.querySelector(
              ".video-slider__video-preview"
            );
            const previousPlayButton = previousContainer.querySelector(
              ".video-slider__play-button"
            );
            const previousPlayIcon =
              previousPlayButton.querySelector(".icon-play");
            const previousPauseIcon =
              previousPlayButton.querySelector(".icon-pause");

            currentPlayingVideo.pause();
            currentPlayingVideo.currentTime = 0;
            currentPlayingVideo.classList.remove("video-slider__video--active");
            previousPreview.classList.remove(
              "video-slider__video-preview--hidden"
            );
            previousPlayIcon.classList.remove("icon--hidden");
            previousPauseIcon.classList.add("icon--hidden");
          }

          video.classList.add("video-slider__video--active");
          preview.classList.add("video-slider__video-preview--hidden");
          playIcon.classList.add("icon--hidden");
          pauseIcon.classList.remove("icon--hidden");
          currentPlayingVideo = video;

          if (video.readyState === 0) {
            video.load();
          }

          video.play().catch(function (error) {
            console.error("Erreur lors de la lecture de la vidéo:", error);
            video.classList.remove("video-slider__video--active");
            preview.classList.remove("video-slider__video-preview--hidden");
            playIcon.classList.remove("icon--hidden");
            pauseIcon.classList.add("icon--hidden");
            currentPlayingVideo = null;
          });
        }
      });
    });

  /* Key figures */
  const figures = document.querySelectorAll(".key-figures__figure");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const numberElement = entry.target.querySelector(
            ".key-figures__figure-number"
          );
          const targetNumber = parseInt(numberElement.textContent);
          const unit = entry.target.querySelector(
            ".key-figures__figure-unit"
          ).textContent;

          let startNumber = 0;
          const duration = 2000; // 2 secondes
          const startTime = performance.now();

          function animate(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);

            // Fonction d'easing pour une animation plus fluide
            const easeOutQuad = (t) => t * (2 - t);

            const currentNumber = Math.floor(
              easeOutQuad(progress) * targetNumber
            );
            numberElement.textContent = currentNumber + unit;

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5, // Déclenche l'animation quand 50% de l'élément est visible
    }
  );

  figures.forEach((figure) => {
    observer.observe(figure);
  });

  /* FAQ */
  document.querySelectorAll(".faq").forEach((faq) => {
    faq.querySelectorAll(".faq__nav-item").forEach((item, index) => {
      item.addEventListener("click", function () {
        faq.querySelectorAll(".faq__nav-item").forEach((item, _index) => {
          item.classList.toggle("faq__nav-item--active", _index === index);
        });
        faq
          .querySelectorAll(".faq__questions-group")
          .forEach((questions, _index) => {
            questions.classList.toggle(
              "faq__questions-group--active",
              _index === index
            );
          });
      });
    });
  });

  /* Collapsible */
  document.querySelectorAll(".collapsible").forEach((collapsible) => {
    const title = collapsible.querySelector(".collapsible__title");
    const content = collapsible.querySelector(".collapsible__content");
    title.addEventListener("click", function () {
      collapsible.classList.toggle("collapsible--open");
      if (collapsible.classList.contains("collapsible--open")) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0px";
      }
    });
  });

  /* Sticky column */
  document
    .querySelectorAll(".product__column-sticky")
    .forEach(function (stickyColumn) {
      const originalOffset = stickyColumn.offsetTop;
      const stickyColumnHeight = stickyColumn.offsetHeight;

      window.addEventListener("scroll", function () {
        const scrollPosition = window.scrollY;

        if (
          scrollPosition >= originalOffset &&
          scrollPosition <
            stickyColumnHeight - (window.innerHeight - originalOffset) &&
          window.innerWidth >= 750
        ) {
          stickyColumn.style.top = `-${scrollPosition - originalOffset + 32}px`;
        }
      });
    });

  /* Product form sticky behavior */
  const productForms = document.querySelectorAll(".product-form");

  if (productForms.length > 0) {
    const productFormObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth < 750) {
            if (entry.isIntersecting) {
              entry.target.classList.remove("product-form--fixed");
            } else {
              entry.target.classList.add("product-form--fixed");
            }
          } else {
            entry.target.classList.remove("product-form--fixed");
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -100px 0px", // Déclenche quand l'élément sort du viewport avec une marge de 100px
      }
    );

    productForms.forEach((productForm) => {
      productFormObserver.observe(productForm);
    });

    // Gérer le redimensionnement de la fenêtre
    window.addEventListener("resize", () => {
      productForms.forEach((productForm) => {
        if (window.innerWidth >= 750) {
          productForm.classList.remove("product-form--fixed");
        }
      });
    });
  }
});
